import { bootstrapApplication } from "@angular/platform-browser";

import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";

declare global {
	var deploy: string;
}

globalThis.deploy = environment.env;

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
